export default __webpack_public_path__ + "static/media/heart.b42a3ea1.svg";